import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import {ProgressbarWithCircleConfigurations} from './progressbar-with-circle.configurations';
import { CommonModule } from '@angular/common';
import { TitleComponent } from '../title/title.component';
import { SimpleCircleChartComponent } from 'app/shared/charts/simple-circle-chart/simple-circle-chart.component';
import { SimpleProgressbarComponent } from 'app/shared/charts/simple-progressbar/simple-progressbar.component';
import { DynamicContentComponent } from 'app/shared/dynamic-content/dynamic-content.component';

@Component({
  selector: 'kla-progressbar-with-circle-chart',
  templateUrl: './progressbar-with-circle-chart.component.html',
  styleUrls: ['./progressbar-with-circle-chart.component.scss'],
  standalone: true,
  imports: [ CommonModule, TitleComponent, SimpleCircleChartComponent, SimpleProgressbarComponent, DynamicContentComponent ]
})
export class ProgressbarWithCircleChartComponent implements OnInit {

  constructor() { }

  @Input()
  public config: ProgressbarWithCircleConfigurations;

  @Input()
  public lineConfig: ProgressbarWithCircleConfigurations;

  public lineColor = '#269bc8';
  public focusedIndex = 0;

  @ViewChild('chartContainer') private chartContainer: ElementRef;

  onContainerKeydown(e: KeyboardEvent) {
    if (e.key === 'Enter') {
      e.preventDefault();
      const items = this.chartContainer?.nativeElement.querySelectorAll('.nav-item');
      if (items?.length) { items[0].focus(); }
    }
  }

  onItemKeydown(e: KeyboardEvent, index: number) {
    const total = this.config.circleCharts.length + 1;
    const items = this.chartContainer?.nativeElement.querySelectorAll('.nav-item') as NodeListOf<HTMLElement>;
    if (!items?.length) { return; }
    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
      e.preventDefault();
      const next = (index + 1) % total;
      this.focusedIndex = next;
      items[next].focus();
    } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
      e.preventDefault();
      const prev = (index - 1 + total) % total;
      this.focusedIndex = prev;
      items[prev].focus();
    } else if (e.key === 'Escape') {
      e.preventDefault();
      const container = this.chartContainer?.nativeElement.closest('[role="group"]') as HTMLElement;
      if (container) { container.focus(); }
    }
  }

  public showLineBetweenCircles = true;

  public showLineAcross = true;
  titleConfig: any;

  ngOnInit() {
    this.titleConfig = {
      header: this.config.header,
      title: this.config.title,
      badges: this.config.badges
    };
    if (this.config.showLineBetweenCircles) {
       this.showLineBetweenCircles = this.config.showLineBetweenCircles;
    }

    if (this.config.showLineAcross) {
       this.showLineAcross = this.config.showLineAcross;
    }
  }

  public generateConfig(value: any, circleText: string) {
    return {
      value: value,
      circleText: circleText,
      width: 125,
      height: 125,
      colorPercent: '#000000',
      colorBackground: '#e2e2e2',
      colorCircle: '#f3f4f6',
      colorForeground: this.config.foregroundColor,
    };
  }

}
